/**
 * HESAP EKSTRESİ — Excel / PDF indirme.
 *
 * İki ekrandan isteniyor (cari hesap detayı ve kasa/banka hesap detayı); ortak
 * yer burası, ekranlar ayrışmasın.
 *
 * EKRANDA GÖRÜNEN SATIRLARIN ID'LERİ gönderilir: süzgeçler (para birimi, durum,
 * tarih, arama) ekranda uygulanıyor, aynı mantığı sunucuda ikinci kez yazmak
 * belgeyle ekranın farklı kümeler göstermesine yol açardı. Sunucu tutarları
 * yine veritabanından okur — buradan giden bir rakam belgeye yazılmaz.
 *
 * Dosya, dekont gibi BLOB olarak alınır: adresi doğrudan açmak JWT başlığını
 * taşımaz ve uç 401 döner.
 */
import api from '@/lib/api';
import { toast } from 'sonner';

const BICIM_ADI = { xlsx: 'Excel', pdf: 'PDF' };

export async function ekstreIndir({ yol, bicim, satirIdler, filtre, ad, bosMesaj, tur, ekGovde }) {
  const belge = tur || 'ekstresi';
  const etiket = BICIM_ADI[bicim] || bicim;
  if (satirIdler && satirIdler.length === 0) {
    toast.info(bosMesaj || 'Dökümü alınacak hareket yok');
    return false;
  }
  const bekleme = toast.loading(`${etiket} ${belge} hazırlanıyor…`);
  try {
    const r = await api.post(`${yol}/${bicim}`,
      // `ekGovde`: aynı ucun farklı sütun setleri (ör. kasa/banka listesi)
      { satir_idler: satirIdler, filtre: filtre || '', ...(ekGovde || {}) },
      { responseType: 'blob' });

    // Dosya adını sunucu belirler (Türkçe harfler ASCII'ye çevrilmiş halde)
    const cd = r.headers?.['content-disposition'] || '';
    const eslesme = /filename="?([^";]+)"?/i.exec(cd);
    const dosya = eslesme ? eslesme[1] : `Ekstre-${ad || 'hesap'}.${bicim}`;

    const url = URL.createObjectURL(r.data);
    const a = document.createElement('a');
    a.href = url;
    a.download = dosya;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 30000);
    toast.success(`${etiket} ${belge} indirildi`, { id: bekleme });
    return true;
  } catch (err) {
    // Hata gövdesi de blob gelir (responseType), okunabilir mesaj için metne çevrilir
    let mesaj = 'Döküm oluşturulamadı';
    try { mesaj = JSON.parse(await err.response.data.text()).detail || mesaj; } catch { /* yoksay */ }
    toast.error(mesaj, { id: bekleme, duration: 7000 });
    return false;
  }
}
